import { getRouteApi } from '@tanstack/react-router';
import { LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { hide } from '~/features/leadDetails/components/Overview/CustomerData/General/utils/hide.ts';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard';
import { FormTextInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormTextInput';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaPersonal } from '~/features/leadDetails/schemas/personal.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type ContactInfoProps = {
    applicant: 1 | 2;
    secondApplicantHidden?: boolean;
};

const ContactInfo: React.FC<ContactInfoProps> = ({ applicant, secondApplicantHidden }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { control } = useFormContext<SchemaPersonal>();
    const { t } = useTranslation();
    const isPhoneDisabled = !canExecuteApplicantCommand({
        applicant,
        commandName: LOAN_REQUEST_COMMANDS.changeApplicantPhone,
        permissions,
    });
    const isEmailDisabled = !canExecuteApplicantCommand({
        applicant,
        commandName: LOAN_REQUEST_COMMANDS.changeApplicantEmail,
        permissions,
    });

    return (
        <div style={hide(!!(secondApplicantHidden && applicant === 2))}>
            <FormCard>
                <FormTextInput
                    control={control}
                    id={`antragsteller${applicant}.personendaten.telefonPrivat`}
                    label={t('PERSONAL_DATA.PHONE')}
                    disabled={isPhoneDisabled}
                />
                <FormTextInput
                    control={control}
                    id={`antragsteller${applicant}.personendaten.email`}
                    label={t('PERSONAL_DATA.MAIL')}
                    disabled={isEmailDisabled}
                />
            </FormCard>
        </div>
    );
};

export default ContactInfo;
